import { AbstractControl, ValidatorFn } from '@angular/forms';

export function phoneNumber(): ValidatorFn {
    const nameRe: RegExp = new RegExp(/^[\d]+$/);
    return (control: AbstractControl): { [key: string]: any } | null =>
        (control.value && !nameRe.test(control.value) && { phoneNumber: true }) || null;
}
